import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const PaginationBar = ({ currentPage, postsPerPage, totalPosts, paginate }) => {

   const [t, i18n] = useTranslation(["global"])

   const pageNumbers = [];

   const [requestedPage, setRequestedPage] = useState(currentPage)

   for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
      pageNumbers.push(i);
   }

   const handleSelectPage = (number) => {
      paginate(number)
      //setRequestedPage(number)
   }

   const handleNextPage = () => {
      handleSelectPage(currentPage + 1)
   }

   const handlePrevPage = () => {
      handleSelectPage(currentPage - 1)
   }

   if (currentPage != null && totalPosts > 0) {
      return (

         <div className="pagination-container d-flex justify-content-center">
            <div className="pagination p-2">

               <button onClick={handlePrevPage} className={`page-nex btn btn-dark m-2 ${currentPage == 1 && "disabled"}`}>
                  {t("particles.prev")}
               </button>


               {pageNumbers.map((number) => (
                  <button
                     key={number}
                     onClick={() => handleSelectPage(number)}
                     className={`page-number btn ${currentPage == number ? "btn-primary" : "btn-dark"} m-2`}
                  >{number}

                  </button>
               ))}

               <button onClick={handleNextPage} className={`page-nex btn btn-dark m-2 ${currentPage > pageNumbers.length - 1 && "disabled"}`}>
                  {t("particles.next")}
               </button>
            </div>
         </div>
      );
   } else return null


};

export default PaginationBar

